import * as React from 'react';
import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Container,
  Stack,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from '@mui/material';

export default function Financing(props) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    loanPurpose: '',
    amount: '',
    notes: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Financing Request Submitted:', formData);
    // You can POST this to an endpoint or trigger AWS logic
    setFormData({
      name: '',
      email: '',
      loanPurpose: '',
      amount: '',
      notes: '',
    });
  };

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, mx: 'auto' }}>
      <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600, mt: 2 }}>
        Financing
      </Typography>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          p: 3,
        })}
      >
        <Container maxWidth="sm">
          <Box display="flex" justifyContent="center">
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                width: '100%',
              }}
            >
              <Typography component="h2" variant="h5" gutterBottom align="center">
                Request Financing Support
              </Typography>
              <Typography variant="body2" paragraph align="center">
                Let us know what you're looking to finance. Fill out the details and we'll follow up with custom options to fit your situation.
              </Typography>

              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <FormControl fullWidth required>
                    <InputLabel id="loan-purpose-label">Loan Purpose</InputLabel>
                    <Select
                      labelId="loan-purpose-label"
                      name="loanPurpose"
                      value={formData.loanPurpose}
                      onChange={handleChange}
                      label="Loan Purpose"
                    >
                      <MenuItem value="Home Purchase">Home Purchase</MenuItem>
                      <MenuItem value="Renovations">Renovations</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    label="Requested Amount ($)"
                    name="amount"
                    type="number"
                    value={formData.amount}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                  <TextField
                    label="Additional Notes"
                    name="notes"
                    multiline
                    rows={4}
                    value={formData.notes}
                    onChange={handleChange}
                    fullWidth
                  />
                  <Button type="submit" variant="outlined">
                    Submit Request
                  </Button>
                </Stack>
              </form>
            </Paper>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
